import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12fef090"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container footer__container" }
const _hoisted_3 = { class: "footer__list" }
const _hoisted_4 = { class: "footer__copyright" }

import { useI18n } from 'vue-i18n';

type TermsLink = {
  routeName: string;
  title: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingFooter',
  setup(__props) {

const { t } = useI18n();

const navLinks: TermsLink[] = [
  {
    routeName: 'PrivacyPolicyWeb',
    title: t('component_the_menu_privacy_policy'),
  },
  {
    routeName: 'TermsOfUseWeb',
    title: t('component_the_menu_terms_of_use'),
  },
  {
    routeName: 'RefundPolicy',
    title: t('component_the_menu_refund_policy'),
  },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navLinks, (link) => {
          return _createElementVNode("li", {
            key: link.routeName,
            class: "footer__item"
          }, [
            _createVNode(_component_router_link, {
              to: { name: link.routeName },
              class: "footer__link",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(link.title), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ])
        }), 64))
      ]),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('component_the_footer_copyright')), 1)
    ])
  ]))
}
}

})